import { useState } from "react";
import { useProjectMutations } from "./data/useProjectMutations";

interface DeleteProjectState {
  isOpen: boolean;
  projectId: string;
  projectName: string;
}

export function useDeleteProject() {
  const [deleteModal, setDeleteModal] = useState<DeleteProjectState>({
    isOpen: false,
    projectId: "",
    projectName: "",
  });

  const { delete: deleteProject, isDeleting } = useProjectMutations();

  const openDeleteModal = (projectId: string, projectName: string) => {
    setDeleteModal({
      isOpen: true,
      projectId,
      projectName,
    });
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      projectId: "",
      projectName: "",
    });
  };

  const confirmDelete = async () => {
    try {
      await deleteProject(deleteModal.projectId);
      closeDeleteModal();
    } catch (error) {
      console.error("Erro ao deletar projeto:", error);
      // O hook useProjectMutations já mostra o toast de erro
    }
  };

  return {
    deleteModal,
    isDeleting,
    openDeleteModal,
    closeDeleteModal,
    confirmDelete,
  };
}